import React from 'react'
import { ClinicScreen } from '@screens/Clinic/ClinicScreen'
import { useAllClinicsTreatments } from '@hooks/useAllClinicsTreatments'
import { useCityTreatments } from '@hooks/useCityTreatments'
import { useIsCityVariant } from '@hooks/useIsCityVariant'
import { useIsAllClinicsVariant } from '@hooks/useIsAllClinicsVariant'

export const Clinic = () => {
  const { data: cityTreatments } = useCityTreatments()
  const { data: allClinicsTreatments } = useAllClinicsTreatments()
  const isCityVariant = useIsCityVariant()
  const isAllClinicsVariant = useIsAllClinicsVariant()

  const categorizedTreatments = (() => {
    if (isCityVariant) return cityTreatments?.categorizedTreatments || []
    if (isAllClinicsVariant) return allClinicsTreatments?.categorizedTreatments || []
    return []
  })()

  return <ClinicScreen categorizedTreatments={categorizedTreatments} />
}
